import React, { useState } from 'react';
import Modal from '../../Modal';

/**
 * Local Pickup (the shipping method) only tells buyers to plan on picking up
 * their order — it doesn't offer them a specific time. Scheduled pickup windows
 * come from a separate opt-in: an active `type = pickup` BookingResource
 * ("Pickup calendar") on the channel, managed under Bookings & Scheduling.
 * This is just an explainer link + modal pointing sellers there.
 */
export default function PickupSchedulingNotice() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                className="help-link pickup-scheduling-trigger"
                onClick={() => setIsOpen(true)}
            >
                Want customers to pick a pickup time? <i className="fa-solid fa-circle-question" />
            </button>

            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title="Scheduled pickup times"
                size="small"
                className="pickup-scheduling-modal"
            >
                <p>
                    Local Pickup by itself just tells buyers to plan on picking up their
                    order in person — it doesn&apos;t give them a specific time to show up.
                </p>
                <p>
                    To let shoppers reserve a pickup window during checkout, create a{' '}
                    <strong>Pickup calendar</strong> under Bookings &amp; Scheduling. Once
                    an active Pickup calendar exists for this channel, a time picker
                    appears automatically on every product that offers Local Pickup —
                    nothing else to turn on here.
                </p>
                <div className="booking-form-actions">
                    <button
                        type="button"
                        className="button secondary"
                        onClick={() => setIsOpen(false)}
                    >
                        Close
                    </button>
                    <a
                        href="/account/bookings"
                        target="_blank"
                        rel="noreferrer"
                        className="button primary"
                    >
                        Open Bookings &amp; Scheduling
                    </a>
                </div>
            </Modal>
        </>
    );
}
